import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {
  FONT_FAMILY,
  googleFontInfo,
} from '../../../../../components/global/CardDesigner/components/CardDesignerCardElements/CardDesignerCardElementText/helpers';

const propTypes = {
  fontFamily: PropTypes.oneOf(Object.values(FONT_FAMILY)).isRequired,
};

const GoogleFontLoader = ({ fontFamily }) => {
  const fontDetails = googleFontInfo.find(x => x.font === fontFamily);

  if (!fontDetails) {
    return null;
  }

  return (
    <Fragment>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
      <link href={fontDetails.stylesheet} rel="stylesheet" />
    </Fragment>
  );
};

GoogleFontLoader.propTypes = propTypes;

export default GoogleFontLoader;
